import React from 'react';
import { Select, MenuItem, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' }
  ];

  const handleChange = (event) => {
    const lang = event.target.value;
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <Select
      value={i18n.language}
      onChange={handleChange}
      sx={{ 
        minWidth: 120,
        '& .MuiSelect-select': {
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }
      }}
    >
      {languages.map((lang) => (
        <MenuItem 
          key={lang.code} 
          value={lang.code}
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <span>{lang.flag}</span>
          <span>{lang.name}</span>
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSwitcher;